// extracted by mini-css-extract-plugin
module.exports = {"myContainer":"Abonnement_myContainer__3A6-y","editButton":"Abonnement_editButton__32kla","item":"Abonnement_item__2qPtc"};